import React from "react";
import AttachFile from "components/AttachFile";

export default function Step5CetatenieStrain({ setFieldValue, formikValues, formikErrors, formikTouched }) {
   return (
      <>
         <AttachFile
            title={"Nif-ul dvs."}
            id={"fileNIF"}
            setFieldValue={setFieldValue}
            value={formikValues.fileNIF}
            error={formikErrors.fileNIF}
            touched={formikTouched.fileNIF}
            obligatoriu={true}
         />
         <AttachFile
            title={"Pasaport-ul dvs."}
            id={"filePasaport"}
            setFieldValue={setFieldValue}
            value={formikValues.filePasaport}
            error={formikErrors.filePasaport}
            touched={formikTouched.filePasaport}
            obligatoriu={true}
         />
         <AttachFile
            title={"Permisul de sedere"}
            id={"filePermisSedere"}
            setFieldValue={setFieldValue}
            value={formikValues.filePermisSedere}
            error={formikErrors.filePermisSedere}
            touched={formikTouched.filePermisSedere}
         />
         <AttachFile
            title={"Alte documente"}
            id={"fileAlteDocumente"}
            setFieldValue={setFieldValue}
            value={formikValues.fileAlteDocumente}
            error={formikErrors.fileAlteDocumente}
            touched={formikTouched.fileAlteDocumente}
         />
      </>
   );
}
